import { useState } from 'react';
import { Button, Col, Row, Title } from 'ui';
import { DeclinedEventsModal } from './declined-events-modal';
import { Invitations } from './invitations';

type P = {
  getPathToEventDetail: (id: string) => string;
};

const Requests = ({ getPathToEventDetail }: P) => {
  const [isDeclinedEventsModalOpened, setIsDeclinedEventsModalOpened] = useState(false);

  return (
    <>
      <Row className="calendar-requests-header">
        <Col flex="auto">
          <Title level={4} marginBottom>
            Upcoming Invitations
          </Title>
        </Col>
        <Col>
          <Button
            onClick={() => {
              setIsDeclinedEventsModalOpened(true);
            }}
            type="link-primary"
          >
            Declined events
          </Button>
        </Col>
      </Row>
      <Invitations getPathToEventDetail={getPathToEventDetail} />
      <DeclinedEventsModal
        getPathToEventDetail={getPathToEventDetail}
        isOpened={isDeclinedEventsModalOpened}
        onCancel={() => {
          setIsDeclinedEventsModalOpened(false);
        }}
      />
    </>
  );
};

export default Requests;
